export default __webpack_public_path__ + "static/banner-software-development-ezgif.com-avif-to-jpg-converter-42131b056be0a6d926b3d4ec71b65264.jpg";